module.exports = __webpack_public_path__ + "img/banner3.16f84e0f.png";